/**
 * Specifies the activity state the test suite is in.
 * tag: 3069
 * @readonly
 * @enum {number} (int)
 */
export enum TestSuiteActivityState {
  Scheduled = 0,
  Completed = 1,
  Cancelled = 2,
}
